
<template>

  <div><div class="d-print-none d-block">
    <nav class="navbar navbar-expand-lg " id="nav" style="font-family:'Montserrat', sans-serif; background-color:rgb(0,58,140);">
     
      <div class="container">
        <a class="navbar-brand float-left"><img src="https://seguimiento.cmimbral.cl/assets/img/logoSeguimiento.png" width="130" responsive></a>
       
                <div class="row">
                    <div class="col-sm-12">
                         <div class="form-group">
                        </div>
                        <div class="input-group mb-3">
                        <div class="input-group-append">
                         <span id="n1" style="color:white"></span>
                           <button  id="btnBuscar" class="btn btn-primary"   style="background-color:rgb(0,56,143); border-color:#003A8C"  @click="ingresar()"><b>{{nombreUsuario}}</b>  <i class="fas fa-sign-out-alt"></i></button>
                        </div>
                        </div>
                    </div>
                </div>




      </div>
     
    </nav></div>
    
    <div >
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
   
   //import { db } from '../firebaseDb';
    //import {storage} from '../firebaseDb';
   // import swal from 'sweetalert';
  // const ref=storage.ref()
    
    export default {
        data() {
            return {
              nombreUser:localStorage.nombreUsuario,
              nombreUsuario:''
            }
        },
        created() {
          // this.verUsuario();
        },
        methods: {
            ingresar(){
              this.$router.push('/')
            },
            verUsuario(nombre){
              this.nombreUsuario=nombre;
            }
        }
    }
</script>
